import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/app-check"; //

class Firebase {
	constructor(props) {
		// let config = props.config;

		const { appCheckRecaptchaKey, ...firebaseConfig } = props.config;

		// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

		//let data = require(`./${login}.json`);
		firebase.initializeApp(firebaseConfig);

		this.appCheck = null;
		if (appCheckRecaptchaKey) {
			const appCheck = firebase.appCheck();
			const prevKey =
				typeof window !== "undefined"
					? window.__RECAPTCHA_SITE_KEY__
					: undefined;

			try {
				if (prevKey && prevKey !== appCheckRecaptchaKey) {
					if (typeof window !== "undefined") {
						window.__APP_CHECK_RELOAD_REQUIRED__ = true;
						if (!window.__APP_CHECK_RELOADING__) {
							window.__APP_CHECK_RELOADING__ = true;
							setTimeout(() => {
								try {
									window.location.reload();
								} catch (e) {}
							}, 0);
						}
					}
				}

				if (!prevKey || prevKey === appCheckRecaptchaKey) {
					appCheck.activate(
						new firebase.appCheck.ReCaptchaEnterpriseProvider(
							appCheckRecaptchaKey
						),
						true // enableAutoRefresh
					);
					if (typeof window !== "undefined") {
						window.__RECAPTCHA_SITE_KEY__ = appCheckRecaptchaKey;
					}
				}
			} catch (e) {
				const msg = String(e && e.message ? e.message : e);
				if (/already been rendered/i.test(msg)) {
				} else {
					throw e;
				}
			}

			try {
				if (typeof appCheck.setTokenAutoRefreshEnabled === "function") {
					appCheck.setTokenAutoRefreshEnabled(true);
				}
			} catch (e) {}

			this.appCheck = appCheck;
		}

		this.auth = firebase.auth();
		this.bd = firebase.database();
		this.storage = firebase.storage();
		this.deleteSessions = async () => {
			try {
				await firebase.app().delete();
			} catch (e) {}
		};

		//
		//
		// const app = initializeApp(config);
		// this.auth = app.auth();
		// this.bd = app.database();
		// this.storage = app.storage();
		// this.deleteSessions = () => {
		// 	app.app().delete();
		// };
	}

	doSignInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password);

	ensureAppCheckToken = async () => {
		if (!this.appCheck) return;

		const withTimeout = (promise, ms) => {
			let timeoutId;
			const timeoutPromise = new Promise((_, reject) => {
				timeoutId = setTimeout(() => reject(new Error("timeout")), ms);
			});

			return Promise.race([promise, timeoutPromise]).finally(() => {
				clearTimeout(timeoutId);
			});
		};

		const tryGetToken = async () => {
			const appCheck = this.appCheck || firebase.appCheck();
			if (appCheck && typeof appCheck.getToken === "function") {
				await appCheck.getToken(true);
			}
		};

		try {
			await withTimeout(tryGetToken(), 2500);
		} catch (e) {
			await new Promise((r) => setTimeout(r, 400));
			try {
				await withTimeout(tryGetToken(), 2500);
			} catch (e2) {}
		}
	};

	doSignOut = async () => {
		try {
			await this.auth.signOut();
		} catch (e) {}

		await this.deleteSessions();
	};
}

export default Firebase;
